import { CART_REVAMP_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

export const onTrackAddonAllListShow = async () => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: CART_REVAMP_TRACKER_TYPE.AddonAllListShow,
    data: {
      scope: 'shop',
      event_category: 'Cart',
    },
  });
};
